import * as React from "react";

export enum AppSection {
    Default = "default",
    Users = "users",
    Clients = "clients",
    Lists = "lists",
    Database = "database"
}

interface IButtonProps {
    name: string
    onClick: () => void
}

interface IMenuProps {
    setSection: (s: AppSection) => void
}

const MenuButton = (props: IButtonProps) =>
    <a href="#" className="button" onClick={props.onClick}>{props.name}</a>

export function Menu(props: IMenuProps) {
    const items = [
        { name: "Brukere", section: AppSection.Users },
        { name: "Klienter", section: AppSection.Clients },
        { name: "Prislister", section: AppSection.Lists },
        { name: "Database", section: AppSection.Database }
    ];
    return <div className="menu">
        {
            // tslint:disable-next-line:jsx-no-lambda
            items.map(i => <MenuButton key={i.section} name={i.name} onClick={() => props.setSection(i.section)} />)
        }
    </div>;
}


// WEBPACK FOOTER //
// ./src/menu.tsx